import { inject, Injectable } from "@angular/core";
import { StateContext } from "@ngxs/store";
import { TableStateModel } from "../table.state.model";
import { Pagination } from "@core/models/pagination.model";
import { TableActions } from "../table.actions";
import { ReferralsService } from "@core/services/referrals.service";
import { getDefaultTableState } from "../table.state";

@Injectable({
  providedIn: 'root',
})
export class ReferralsHandler {

    constructor() {}
    referralsService = inject(ReferralsService);

    handleReferralsLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
        this.referralsService.getReferralsWithCount({ ...params }).subscribe({
          next: (response) => {
            ctx.dispatch(
              new TableActions.LoadTableDataSuccess({
                tableKey: 'referrals',
                data: response.data?.data,
                totalCount: response.data?.total_count,
              })
            );
          },
          error: (error) => {
            ctx.dispatch(
              new TableActions.LoadTableDataFailure({
                tableKey: 'referrals',
                error: error.message,
              })
            );
          },
        });
      }

      filterReferralList(
        ctx: StateContext<TableStateModel>,
        action: TableActions.FilterReferralList
      ) {
        return this.referralsService
          .getReferralsWithCount(undefined, action.payload.filter)
          .subscribe({
            next: (response) => {
              ctx.dispatch(
                new TableActions.LoadTableDataSuccess({
                  tableKey: 'referrals',
                  data: response.data?.data,
                  totalCount: response.data?.total_count,
                })
              );
            },
            error: (error) => {
              ctx.dispatch(
                new TableActions.LoadTableDataFailure({
                  tableKey: 'referrals',
                  error: error.message,
                })
              );
            },
          });
      }

      handleGetMetadata(ctx: StateContext<TableStateModel>) {
        this.referralsService.getReferralMetadata().subscribe({
          next: (response) => {
              const currentState = ctx.getState();
              const currentReferrals = currentState.referrals;
              ctx.patchState({
                referrals: {
                  ...currentReferrals || getDefaultTableState(),
                  referralMetadata: response.data,
                },
              });
          },
          error: (error) => {
            ctx.dispatch(
              new TableActions.LoadTableDataFailure({
                tableKey: 'referrals',
                error: error.message,
              })
            );
          },
        });
      }

     
}


